import { Dialog, DialogTitle, DialogDescription, DialogBody, DialogActions } from '@/components/catalyst-ui/dialog'
import { Button } from '@/components/catalyst-ui/button'
import { Input } from '@/components/catalyst-ui/input'
import { Field, Label } from '@/components/catalyst-ui/fieldset'
import { XMarkIcon } from '@heroicons/react/24/solid'

export default function EditDNSRecordDialog({
  open,
  onClose,
  domainName,
  record,
  onRecordChange,
  onSave,
  isLoading = false,
}) {
  if (!record) return null

  return (
    <Dialog open={open} onClose={onClose} className="!rounded-xl p-5 !bg-[#FAFAFA]">
      <div className="flex items-center justify-between">
        <DialogTitle className="!text-lg !font-semibold !text-[#09090B]">Edit DNS Record</DialogTitle>
        <button
          onClick={onClose}
          className="text-black hover:text-zinc-600 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2 rounded-full"
        >
          <XMarkIcon className="w-5 h-5 -mt-6 -mr-2.5" />
        </button>
      </div>
      <DialogBody className="!mt-2">
        <DialogDescription className="!text-sm !font-medium !text-[#A1A1AA]">
          Update the DNS record for {domainName}
        </DialogDescription>
        <form className="space-y-2 mt-4">
          <Field>
            <Label className="text-sm font-medium text-gray-700">Type</Label>
            <Input
              type="text"
              value={record.editType}
              disabled
              className="!bg-gray-100 !text-gray-500 cursor-not-allowed"
            />
            <p className="text-sm font-medium text-[#A1A1AA] mt-1">Record type cannot be changed</p>
          </Field>
          
          <Field>
            <Label className="text-sm font-medium text-gray-700">Host</Label>
            <Input
              type="text"
              value={record.editHost}
              disabled
              className="!bg-gray-100 !text-gray-500 cursor-not-allowed"
            />
            <p className="text-sm font-medium text-[#A1A1AA] mt-1">Host cannot be changed</p>
          </Field>
          
          <Field>
            <Label className="text-sm font-medium text-gray-700">Value/Address <span className="text-[#B91C1C]">*</span></Label>
            <Input
              type="text"
              value={record.editValue}
              onChange={(e) => onRecordChange({ ...record, editValue: e.target.value })}
              placeholder="Enter new value"
            />
          </Field>
          
          {record.editType === 'MX' && (
            <Field>
              <Label className="text-sm font-medium text-gray-700">Priority</Label>
              <Input
                type="number"
                value={record.editPriority}
                onChange={(e) => onRecordChange({ ...record, editPriority: e.target.value })}
                placeholder="10"
              />
            </Field>
          )}
        </form>
      </DialogBody>
      <DialogActions className="!mt-4 !flex !flex-col sm:!flex-row !gap-3">
        <Button 
          onClick={onClose}
          outline
          className="w-full sm:flex-1 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
        >
          Cancel
        </Button>
        <Button 
          onClick={onSave}
          color="dark"
          disabled={isLoading}
          className="w-full sm:flex-1 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
        >
          {isLoading ? 'Saving...' : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
